import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { useAuthStore } from '@/stores/authStore';
import { useUpdateProfile } from '@/hooks/useAuth';

export function ProfilePage() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const update = useUpdateProfile();
  const [name, setName] = useState(user?.name ?? '');

  const save = async () => {
    if (!name.trim()) return;
    await update.mutateAsync({ name });
  };

  return (
    <Card title={t('web.nav.profile')}>
      <div className="space-y-3">
        <Input
          label={t('auth.your_name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Input label={t('auth.phone_label')} value={user?.phone ?? ''} readOnly disabled />
        <div>
          <p className="mb-1 text-sm font-medium text-slate-700">{t('common.language')}</p>
          <LanguageSwitcher />
        </div>
        <div className="flex gap-2 pt-3">
          <Button onClick={() => void save()} loading={update.isPending}>
            {t('common.save')}
          </Button>
          <Button variant="danger" onClick={() => void logout()}>
            {t('web.nav.logout')}
          </Button>
        </div>
      </div>
    </Card>
  );
}
